import React, { useContext, useState } from "react";
import { AuthContext } from "../providers/AuthProvider";
import { signInWithEmail, signUpWithEmail } from "../firebase";
import "../css/login.scss";

const Login = () => {
  let { signInWithGoogle } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const signIn = () => {
    signInWithEmail(email, password)
      .then((data) => {
        // console.log("finished login", data);
      })
      .catch(function (error) {
        // Handle Errors here.
        setErrorCode(error.code);
        setErrorMessage(error.message);
      });
  };

  function signUp() {
    // console.log("sign up func", auth.createUserWithEmailAndPassword);

    signUpWithEmail(email, password)
      .then(function (data) {
        // console.log("finished setup of login", data);
      })
      .catch(function (error) {
        // Handle Errors here.
        setErrorCode(error.code);
        setErrorMessage(error.message);
      });
  }

  return (
    <div className="loginContainer">
      <header>
        <h1>HES</h1>
        <svg
          preserveAspectRatio="none"
          width="770"
          height="640"
          viewBox="0 0 770 640"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="770"
            height="640"
          >
            <rect width="770" height="640" fill="#C4C4C4" />
          </mask>
          <g mask="url(#mask0)">
            <g filter="url(#filter0_d)">
              <path
                d="M-2.94032 -35.5486L771.897 -147.157L771.497 103.711L-7.80466 284.498L-2.94032 -35.5486Z"
                fill="#373737"
              />
            </g>
            <g filter="url(#filter1_d)">
              <path
                d="M150.725 247.518L776 102L813.453 268.861L191.686 418.134L150.725 247.518Z"
                fill="#505050"
              />
            </g>
            <g filter="url(#filter2_d)">
              <path
                d="M-76.9142 -20.2092L122.079 -63.7385L234.833 405.918L-4.00006 465L-76.9142 -20.2092Z"
                fill="#625F5F"
              />
            </g>
            <g filter="url(#filter3_d)">
              <path
                d="M-65.6446 478.339L813.917 267.174L853.603 432.477L-25.9589 643.641L-65.6446 478.339Z"
                fill="#3E3D3D"
              />
            </g>
            <g filter="url(#filter4_d)">
              <path
                d="M-75.3596 475.527L480.313 346.692L517.81 512.526L-34.6352 645.156L-75.3596 475.527Z"
                fill="#2C2C2C"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_d"
              x="-11.8047"
              y="-147.157"
              width="787.702"
              height="439.655"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d"
              x="146.725"
              y="97.6534"
              width="673.193"
              height="328.481"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
            <filter
              id="filter2_d"
              x="-122.114"
              y="-67.7519"
              width="361.343"
              height="540.752"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
            <filter
              id="filter3_d"
              x="-69.6446"
              y="267.174"
              width="927.247"
              height="384.467"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
            <filter
              id="filter4_d"
              x="-79.3596"
              y="342.371"
              width="603.36"
              height="310.785"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>

        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <polygon fill="white" points="0,100 100,0 100,100" />
        </svg> */}
      </header>

      <div className="loginControls">
        <div className="loginInputs">
          <input
            onChange={(e) => setEmail(e.target.value)}
            name="email"
            type="text"
            id="userEmail"
            value={email}
            placeholder="email"
          />

          <input
            onChange={(e) => setPassword(e.target.value)}
            name="password"
            type="password"
            id="userPassword"
            placeholder="password"
            value={password}
          />
        </div>

        <div className="loginErrorCodes">
          <p>{errorCode}</p>
          <p>{errorMessage}</p>
        </div>

        <div className="signInLocalButtons">
          <button className="signIn actionButton primaryColor" onClick={signIn}>
            Sign In
          </button>
          <div></div>
          <button
            className="signUp actionButton secondaryColor"
            onClick={signUp}
          >
            Sign Up
          </button>
        </div>

        <button
          className="signInGoogleButton actionButton greyColor"
          onClick={signInWithGoogle}
        >
          Sign In With Google
        </button>
      </div>
    </div>
  );
};

export default Login;
